export const colorRed = '#E85C70';
